module.exports = __webpack_public_path__ + "static/media/IMG_0769.d7e6cb0f.JPG";